import Vue from 'vue';
import Vuex from 'vuex';
// import AppInner from './Layouts/AppInner.vue';

import { auth } from './auth.module';

Vue.use(Vuex);
// Vue.use(AppInner);

export default new Vuex.Store({
  modules: {
    auth,
   
  }
});
